import { ImageSquare } from "@phosphor-icons/react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_before-after-epoxy/artifacts/9438t85m_7357295930699066262%282%29.webp";

export const COMPANY_NAME = "New Era Landscaping";

export function BrandMark({ size = "md", showWordmark = true }) {
  const sizes = {
    sm: { box: "w-9 h-9", img: 36 },
    md: { box: "w-11 h-11", img: 44 },
    lg: { box: "w-14 h-14", img: 56 },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className="flex items-center gap-3" data-testid="brand-mark">
      <div
        className={`${s.box} rounded-lg overflow-hidden flex items-center justify-center bg-black/40 border border-white/10 shrink-0`}
        style={{ boxShadow: "0 0 18px rgba(var(--epx-primary-rgb),0.25)" }}
      >
        <img
          src={LOGO_URL}
          alt={`${COMPANY_NAME} logo`}
          width={s.img}
          height={s.img}
          className="object-contain w-full h-full"
          loading="eager"
        />
      </div>
      {showWordmark && (
        <div className="leading-tight">
          <p className="overline">Epoxy Visualizer</p>
          <h1 className="font-heading text-base sm:text-lg font-semibold leading-none mt-0.5">
            {COMPANY_NAME}
          </h1>
        </div>
      )}
    </div>
  );
}

export function BrandIconSquare() {
  return (
    <div className="w-9 h-9 rounded-lg overflow-hidden bg-black/40 border border-white/10 flex items-center justify-center">
      <img
        src={LOGO_URL}
        alt={`${COMPANY_NAME} logo`}
        className="object-contain w-full h-full"
      />
      <ImageSquare className="hidden" />
    </div>
  );
}
